jQuery(function() {

  // https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
  var isElementInViewport = function(el) {
      var rect     = el.getBoundingClientRect(),
          vWidth   = window.innerWidth || doc.documentElement.clientWidth,
          vHeight  = window.innerHeight || doc.documentElement.clientHeight,
          efp      = function (x, y) { return document.elementFromPoint(x, y) };     

      // Return false if it's not in the viewport
      if (rect.right < 0 || rect.bottom < 0 
              || rect.left > vWidth || rect.top > vHeight)
          return false;

      // Return true if any of its four corners or top-middle are visible
      return (
            el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.left+(rect.right-rect.left)/2, rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
  },
  detectVisible = function(elems) {
      return function () {
        elems.each(function(n, el) {
          var $el = $(el);
          if ($el.hasClass('check-is-visible--is-hidden')) {
            if (isElementInViewport(el)) {
              $el.addClass('check-is-visible--is-visible');
              $el.removeClass('check-is-visible--is-hidden');
            }              
          }
        });
      }
  }

  var $elems = jQuery('.check-is-visible')
  $elems.addClass('check-is-visible--is-hidden');
  detectVisible($elems);
  jQuery(window).on('load resize scroll', detectVisible($elems)); 

});
